module.exports = __webpack_public_path__ + "img/wide.e27ebe88.jpg";